import React, { PureComponent }         from 'react'
import PropTypes                        from 'prop-types'
import MajorItem                        from '../MajorItem'
import { getMajors }                    from '../../api/major'
import { getSpecialtiesByUniversityId } from '../../api/school'
import './index.less'

class MajorList extends PureComponent {

  static propTypes = {
    history: PropTypes.object,
    schoolId: PropTypes.number,
    categoryId: PropTypes.number,
  }

  state = {
    classifyList: [],
    openedId: null,
  }

  getList = this.props.schoolId
    ? () => getSpecialtiesByUniversityId(this.props.schoolId)
    : () => getMajors({ _s_category_id: this.props.categoryId })

  componentDidMount() {
    this.getList().then(res => {
      const classifyMap = {}
      const classifyList = []
      res.data.forEach(major => {
        const classify = major.classify
        if (classifyMap[classify.id]) {
          classifyMap[classify.id].children.push(major)
        } else {
          classifyMap[classify.id] = classify
          classify.children = [major]
          classifyList.push(classify)
        }
      })
      this.setState({
        classifyList,
      })
    })
  }

  getMajors(classifyId) {
    const { openedId } = this.state
    if (openedId === classifyId) {
      this.setState({
        openedId: null,
      })
    } else {
      this.setState({
        openedId: classifyId,
      })
    }
  }

  renderMajorList(list) {
    const { history } = this.props
    if (Array.isArray(list)) {
      return list.map((d, i) =>
        <MajorItem
          key={i}
          major={d}
          history={history}/>
      )
    }
  }

  render() {
    const { classifyList, openedId } = this.state
    return classifyList.map((d, i) => (
      <div className="classify" key={i}>
        <div className="classify-item" onClick={this.getMajors.bind(this, d.id)}>
          {openedId === d.id
            ? <svg className="icon icon-indicator_1">
              <use xlinkHref="#icon-indicator_1"></use>
            </svg>
            : <svg className="icon icon-indicator_2">
              <use xlinkHref="#icon-indicator_2"></use>
            </svg>}
          <h4>{d.name}</h4>
          <span>{d.children.length}个专业</span>
        </div>
        {openedId === d.id && <div className="major-list">{this.renderMajorList(d.children)}</div>}
      </div>
    ))
  }
}

export default MajorList


// WEBPACK FOOTER //
// ./src/components/MajorList/index.js